import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { openNewWindow } from 'js/utils/url.util';
import { useShowNotification } from 'js/components/common/Notifications';

export const useLaunchInNewWindow = () => {
    const translate = useTranslations();
    const showNotification = useShowNotification();

    const handlePopupBlocker = useCallback(() => {
        showNotification({
            displayTime: 7,
            message: translate('playtech.mobile.system.games.popup-blocker')
        });
    }, [translate, showNotification]);

    const openInExistingWindow = useCallback(({ gameWindow, launcherUrl }) => {
        gameWindow.location.href = launcherUrl;
        gameWindow.focus();

        return gameWindow;
    }, []);

    return useCallback(({ launcherUrl, gameWindow }) => gameWindow
        ? openInExistingWindow({ gameWindow, launcherUrl })
        : openNewWindow(launcherUrl, '', undefined, handlePopupBlocker),
    [handlePopupBlocker, openInExistingWindow]);
};
